module.exports = __webpack_public_path__ + "img/young-crazy-hipster-with-beard-and-glass.df49b6fd.png";